var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { memo } from 'react';
import { TableBodyCell } from '@pocketlaw/tetris';
import { DocumentPreviewChip } from 'app/domains/documents';
import { getSearchEntityLink } from 'app/domains/global-search';
import { SearchEntityTypeEnum } from 'shared/domains/apollo/generated/types';
import { TypeAvatarWithLabel } from 'shared/domains/common-ui';
import { entityTypeToAvatarType } from './utils';
import { useSafeSearchResultText } from '../../../../hooks/useSafeSearchResultText';
import { TITLE_CELL_WIDTH } from '../../constants';
const SUPPORTED_ENTITY_TYPES = [
    SearchEntityTypeEnum.Document,
    SearchEntityTypeEnum.DocumentComposed,
    SearchEntityTypeEnum.DocumentFreetext,
    SearchEntityTypeEnum.DocumentUploaded,
];
function TitleCellComponent(props) {
    const { entityType, entityId, name, highlight, selected, onSelect } = props, rest = __rest(props, ["entityType", "entityId", "name", "highlight", "selected", "onSelect"]);
    const to = getSearchEntityLink(entityType, entityId);
    const avatarType = entityTypeToAvatarType(entityType);
    const { result, showNameOnly } = useSafeSearchResultText({ name, highlight });
    const avatar = (<TypeAvatarWithLabel truncate size="sm" type={avatarType} title={name} subtitle={showNameOnly ? undefined : result} link={to} selected={selected} onSelect={onSelect}/>);
    if (SUPPORTED_ENTITY_TYPES.includes(entityType)) {
        return (<TableBodyCell maxWidth={TITLE_CELL_WIDTH} {...rest}>
        <DocumentPreviewChip documentId={entityId}>{avatar}</DocumentPreviewChip>
      </TableBodyCell>);
    }
    return (<TableBodyCell maxWidth={TITLE_CELL_WIDTH} {...rest}>
      {avatar}
    </TableBodyCell>);
}
export const TitleCell = memo(TitleCellComponent);
